<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="success" size="mini" @click="handleAdd({})">新增</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="title" label="标题" width="200"></el-table-column>
            <el-table-column prop="path" label="路径" width="230"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="230"></el-table-column>
            <el-table-column prop="appid" label="appid" width="230"></el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini"
                                   @click="handDelete(scope.row)">删除
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="miniCardId" :hidden="true">
                    <el-input v-model=form.miniCardId></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId" placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="页面路径">
                    <el-input v-model=form.path clearable placeholder="小程序页面路径 参考 http://wechat.lechun.cc/link_lcasdf"></el-input>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model=form.title clearable placeholder="卡片上面的文案"></el-input>
                </el-form-item>
                <el-form-item label="素材" v-show="show">
                    <el-select v-model="form.media_id" placeholder="请选择素材"
                               filterable
                               remote
                               clearable
                               reserve-keyword
                               :remote-method="getMediaList"
                               :loading="loading">
                        <el-option v-for="item in mediaData"
                                   :key="item.mediaId"
                                   :label="item.title"
                                   :value="item.mediaId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save()">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getMiniCardList, saveMiniCard, deleteMiniCard,getMediaDataList,getPlatformList2} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                loading: true,
                dialogFormVisible: false,
                mediaData:[],
                form: {
                    media_id: '',
                    type: 0,
                    title: '',
                    path: '',
                    platformId:4
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                show:false,
                mediaFormInline:{
                    currentPage: 1,
                    pageSize: 15,
                    title:'',
                    recordsTotal: 0,
                },
                platformDisabled: false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            getPlatformList2().then((res) => {
                this.platformData = res.data;
            });
            this.getList();
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                getMiniCardList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;
                })
            },
            getMediaList(queryString){
                this.mediaFormInline.title=queryString;
                getMediaDataList(this.mediaFormInline).then((res) => {
                    this.loading = false;
                    this.mediaData = res.data.value.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(row){
                this.dialogFormVisible = true;
                this.show=true;
                this.form = {
                    media_id: '',
                    type: 0,
                    title: '',
                    path: '',
                    platformId:4
                }
                this.getMediaList('');
                this.platformDisabled = this.form.platformId!=='';
            },
            handleEdit(data){
                this.show=false;
                this.dialogFormVisible = true;
                this.platformDisabled = true;
                this.form = {
                    miniCardId: data.miniCardId,
                    media_id: data.media_id,
                    type: data.type,
                    title: data.title,
                    path: data.path,
                    platformId:data.platformId,
                };
            },
            handDelete(row){
                if (confirm("删除不可撤销，确认删除吗？")) {
                    this.loading = true;
                    deleteMiniCard({miniCardId: row.miniCardId}).then((res) => {
                        //console.log(res);
                        this.loading = false;
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            save(){
                console.log(this.form);
                if (this.form.title == "") {
                    this.$message({
                        message: "请输入标题",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.path == "") {
                    this.$message({
                        message: "请输入路径",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.platformId == "") {
                    this.$message({
                        message: "请选择平台",
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                saveMiniCard(this.form).then((res) => {
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>
<style>
    .p{
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/wechat/miniCard.vue